import * as React from 'react';
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import AddProjectScoreCardQuestion from 'Components/ScoreCardQuestions/AddProjectScoreCardQuestion';
import ProjectScoreCardQuestion from 'Components/ScoreCardQuestions/ProjectScoreCardQuestion';
import { SystemGrid } from 'library'
import { GridColumn as Column, GridDetailRow } from "@progress/kendo-react-grid";
import { IFormGridProps } from 'library/types/IFormGridProps'
import { SystemActionCell } from '../../library/grid/SystemActionCell';

class DetailComponent extends GridDetailRow {    
    render() {
        return <SystemGridAndForm label={this.props.dataItem.Name + ' - ' + this.props.dataItem.SubName} form={AddProjectScoreCardQuestion} grid={ProjectScoreCardQuestion} data={this.props.dataItem.ScoreCardGroupId} securityObject="Top.ScoreCardQuestions" />
    }
}

const ProjectScoreCardGroup = (props: IFormGridProps) => {
    const url = "/ScoreCardVersionGroup/ScoreVersionGroupByScoreCardId/" + props.data;

    const [counter, setCount] = React.useState(1500);

    const RefreshGrid = () => {
        setTimeout(() => {
            setCount(counter + 1);
        }, 500)
    }

    return <SystemGrid onRowClick={props.onRowClick} pageable={true} dataSource={url} refresh={props.refresh + counter} detail={DetailComponent} expandField="expanded" >
            <Column key={1} field="Name" title="Group Name" width="auto" />
            <Column key={2} field="SubName" title="Sub Name" width="auto" />
            <Column key={3} field="SortOrder" title="Sort Order" width="auto" />
            <Column key={4} field="" title="Action" width="auto" cell={(props) => <SystemActionCell {...props} onDeleteSuccess={RefreshGrid} showDelete={true} showAudit={false} schema="Top" table="ScoreCardGroups" deleteUrl='/ScoreCardVersionGroup' />} columnMenu={null} />
    </SystemGrid>
}

export default ProjectScoreCardGroup